import { createContext, useCallback, useContext, useRef, useState } from 'react';
import { useNotifications } from '../context/NotificationContext';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const { addNotification } = useNotifications();
  const [msg, setMsg] = useState('');
  const [kind, setKind] = useState('ok');
  const [show, setShow] = useState(false);
  const timer = useRef(null);

  const toast = useCallback(
    (message, k = 'ok') => {
      setMsg(message);
      setKind(k);
      setShow(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setShow(false), 2600);
      // Lưu vào lịch sử chuông (bỏ qua cảnh báo nhập liệu 'warn' cho đỡ nhiễu).
      if (k !== 'warn') addNotification(message, k);
    },
    [addNotification]
  );

  const bg = kind === 'danger' ? 'var(--danger)' : kind === 'warn' ? 'var(--warn)' : 'var(--accent2)';
  const color = kind === 'warn' ? '#3a2c05' : '#06281c';

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className={`toast${show ? ' show' : ''}`} style={{ background: bg, color }}>
        {msg}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
